import { match } from 'ts-pattern';
import { IGetAllFavoriteItemByTypeUsecase } from '@modules/favorite/domain/ports/getAllFavoriteItemByType.usecase.port';
import { TabNameForMemberFavoriteResult } from '@modules/libs/graphql/generated/graphql';
import { ModuleType } from '@shared/types/module.type';
import { IFavoriteRepository } from '../ports/favorite.repository.port';
export class GetAllFavoriteItemByTypeUsecase implements IGetAllFavoriteItemByTypeUsecase {
  constructor(private readonly favoriteRepository: IFavoriteRepository) {}
  async handle(module: ModuleType): IGetAllFavoriteItemByTypeUsecase.output {
    const type = match(module).with(ModuleType.Product, () => TabNameForMemberFavoriteResult.Product).with(ModuleType.Collection, () => TabNameForMemberFavoriteResult.Collection).with(ModuleType.Recipe, () => TabNameForMemberFavoriteResult.Recipe).otherwise(() => null);
    const result = await this.favoriteRepository.getAllFavoriteItemByType(type);
    return result;
  }
}